import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryCards() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            分类浏览
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            从不同维度深入了解黄游下戟这一经典典故的丰富内涵
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 border border-background-200/70 hover:border-primary-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}